export default __webpack_public_path__ + "static/media/bidifylogo_bnb.16ef1eb5.png";